import { DMPEVENT } from '@/app/modules/Metrics/loaders/OneDMP';
import { Cloneable } from '@/app/tools/Cloneable';
import { deepSerializationCopy } from '@/app/tools/objectUtils';
import { DivolteHolder } from '@/modules/Metrix/misc';

/**
 * Костыль для копирования начальных данных eventMap из CSC в OneDMP, тк там должно быть одно и то-же
 *
 * @see CustomRelay
 */
export default class CSCToDMPCloneStruct extends Cloneable {
    constructor(public divolte: DivolteHolder, public dmpType: DMPEVENT) {
        super();
    }

    public clone() {
        return new CSCToDMPCloneStruct(
            deepSerializationCopy(this.divolte),
            this.dmpType
        );
    }
}
